import { render, staticRenderFns } from "./ArgesTarjetasLista.vue?vue&type=template&id=49c23ade&scoped=true&"
import script from "./ArgesTarjetasLista.vue?vue&type=script&lang=ts&"
export * from "./ArgesTarjetasLista.vue?vue&type=script&lang=ts&"
import style0 from "./ArgesTarjetasLista.vue?vue&type=style&index=0&id=49c23ade&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c23ade",
  null
  
)

export default component.exports